import React, { useState } from 'react';
import { ShoppingCart, Zap, Clock, EyeOff, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import BuyDialog from './BuyDialog';

export default function BuySection() {
  const [open, setOpen] = useState(false);

  return (
    <section
      className="max-w-7xl mx-auto px-3 sm:px-6 pb-12"
      data-testid="buy-section"
    >
      <div
        className="relative rounded-3xl border-[3px] border-[#3a1064] shadow-[0_8px_0_#3a1064] overflow-hidden"
        style={{
          background:
            'linear-gradient(135deg,#3a1064 0%,#9d3dff 35%,#ff2bd6 70%,#ffd900 110%)',
        }}
      >
        {/* Decorative shapes */}
        <div
          aria-hidden
          className="absolute inset-0 opacity-30 pointer-events-none"
          style={{
            backgroundImage:
              'radial-gradient(circle at 12% 18%, rgba(255,255,255,0.5) 1px, transparent 2px), radial-gradient(circle at 78% 64%, rgba(255,255,255,0.4) 1px, transparent 2px), radial-gradient(circle at 38% 78%, rgba(255,255,255,0.3) 1px, transparent 2px)',
            backgroundSize: '40px 40px, 60px 60px, 32px 32px',
          }}
        />
        <div
          aria-hidden
          className="absolute -top-10 -right-10 h-48 w-48 rounded-full opacity-30 pointer-events-none"
          style={{ background: '#ffd900', filter: 'blur(40px)' }}
        />

        <div className="relative p-6 sm:p-10 grid grid-cols-1 lg:grid-cols-[1fr_auto] gap-6 items-center">
          <div className="space-y-3">
            <div className="inline-flex items-center gap-2 bg-[#ffd900] border-2 border-[#3a1064] rounded-full px-3 py-1 shadow-[0_2px_0_#3a1064]">
              <Zap className="h-4 w-4 text-[#3a1064]" />
              <span className="font-black text-[#3a1064] text-xs uppercase tracking-wider">
                Skip the queue
              </span>
            </div>

            <h2
              className="text-white font-black tracking-tight drop-shadow-[0_3px_0_#3a1064]"
              style={{ fontSize: 'clamp(1.75rem, 3.2vw, 2.6rem)', lineHeight: 1.05 }}
            >
              Don&apos;t want to wait for a trade?<br />
              <span className="text-[#ffd900]">Don&apos;t trust the process?</span>
            </h2>

            <p className="text-white/95 font-bold text-base sm:text-lg drop-shadow-[0_1px_0_#3a1064] max-w-2xl">
              Buy directly from the developers of Sprite Vault.{' '}
              Click below to <span className="text-[#ffd900] font-black">anonymously</span> request whatever sprite you desire — name your own price.
            </p>

            <div className="flex flex-wrap gap-3 pt-1">
              <div className="flex items-center gap-1.5 text-white font-black text-xs sm:text-sm bg-black/30 backdrop-blur-sm border-2 border-white/30 rounded-full px-3 py-1.5">
                <EyeOff className="h-3.5 w-3.5" /> 100% anonymous
              </div>
              <div className="flex items-center gap-1.5 text-white font-black text-xs sm:text-sm bg-black/30 backdrop-blur-sm border-2 border-white/30 rounded-full px-3 py-1.5">
                <Clock className="h-3.5 w-3.5" /> Usually within 24h
              </div>
              <div className="flex items-center gap-1.5 text-white font-black text-xs sm:text-sm bg-black/30 backdrop-blur-sm border-2 border-white/30 rounded-full px-3 py-1.5">
                <ShoppingCart className="h-3.5 w-3.5" /> Name your price
              </div>
            </div>
          </div>

          <div className="flex justify-center lg:justify-end">
            <Button
              data-testid="open-buy-dialog-btn"
              onClick={() => setOpen(true)}
              className="h-16 sm:h-20 px-6 sm:px-8 rounded-2xl border-[3px] border-[#3a1064] bg-[#ffd900] hover:bg-yellow-300 text-[#3a1064] font-black shadow-[0_6px_0_#3a1064] text-lg sm:text-2xl group transition-transform hover:-translate-y-0.5"
            >
              <ShoppingCart className="h-6 w-6 sm:h-7 sm:w-7 mr-2 sm:mr-3" />
              Buy a sprite now
              <ArrowRight className="h-5 w-5 sm:h-6 sm:w-6 ml-2 sm:ml-3 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>
        </div>

        <div className="relative bg-black/20 backdrop-blur-sm border-t-2 border-white/20 px-6 py-3 text-center">
          <p className="text-white/80 font-bold text-xs">
            Devs review every offer manually · Payment link &amp; meet-up details delivered via in-app notifications
          </p>
        </div>
      </div>

      <BuyDialog open={open} onOpenChange={setOpen} />
    </section>
  );
}
